.avatar {
  --size: 32px;
  position: relative;
  width: var(--size);
  height: var(--size);
  border-radius: 50%;
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: var(--vc-weight-bold);
  font-size: calc(var(--size) * 0.36);
  color: #fff;
  background: hsl(var(--hue, 210) 60% 48%);
  // No overflow clipping here: it would cut the status dot that sits on the circle's edge.
  user-select: none;
  letter-spacing: 0.02em;

  &.xs {
    --size: 22px;
  }
  &.sm {
    --size: 26px;
  }
  &.md {
    --size: 32px;
  }
  &.lg {
    --size: 44px;
  }
  &.xl {
    --size: 64px;
  }
  &.xxl {
    --size: 96px;
    border-radius: 24px;
    font-size: 34px;
  }

  .img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit; // the image clips itself, so the dot stays whole
  }

  // Online/offline dot on the lower-right edge of the circle, with a surface-coloured ring.
  .status {
    position: absolute;
    right: -1px;
    bottom: -1px;
    width: max(10px, calc(var(--size) * 0.28));
    height: max(10px, calc(var(--size) * 0.28));
    border-radius: 50%;
    border: 2px solid var(--vc-surface);
    background: var(--vc-green);
    box-sizing: border-box;

    &.statusOff {
      background: var(--vc-text-faint);
    }
  }

  &.more {
    background: var(--vc-gray-soft);
    color: var(--vc-text-secondary);
  }
}

.group {
  display: inline-flex;
  align-items: center;

  .avatar {
    box-shadow: 0 0 0 2px var(--vc-surface);
  }

  .avatar + .avatar {
    margin-left: -8px;
  }
}
